module.exports = __webpack_public_path__ + "static/img/BQ-BO.bed11784.svg";